export default {
  title: 'Traducciones',
  subtitle: 'Las palabras de esta forma, en otro idioma. Lo que deje en blanco se muestra en el '
    + 'idioma propio de la forma — nunca en blanco, nunca un código.',
  addLanguage: 'Agregar un idioma',
  removeLanguage: 'Quitar este idioma',
  removeLanguageConfirm: (name) => `¿Quitar ${name} de esta forma? Todos los que la leen en ${name} `
    + `vuelven al idioma propio de la forma.`,
  noLanguagesYet: 'Esta forma está escrita en un solo idioma.',
  baseLanguageIs: (name) => `Esta forma está escrita en ${name}.`,
  progress: (done, total) => `${done} de ${total} traducidas`,
  allTranslated: 'Todo está traducido.',
  untranslatedCount: (n) => (n === 1 ? '1 sin traducir' : `${n} sin traducir`),
  staleCount: (n) => (n === 1
    ? '1 se tradujo de un texto que ya cambió'
    : `${n} se tradujeron de un texto que ya cambió`),
  showOnlyMissing: 'Mostrar solo lo que falta',
  original: 'Original',
  translation: 'Traducción',
  stale: 'El original cambió',
  stillCorrect: 'Esta traducción sigue sirviendo para el texto nuevo',
  staleHelp: 'Esto se tradujo de un texto que después se editó, así que la forma muestra el original '
    + 'hasta que se vuelva a traducir. Que los dos idiomas hagan preguntas distintas es peor que '
    + 'tener uno sin traducir.',
  saveTranslations: 'Guardar traducciones',
  savedTranslations: 'Traducciones guardadas',
  saveFailed: 'No se pudieron guardar esas traducciones.',
  nothingToSaveYet: 'Todavía no hay nada traducido, así que no hay nada que guardar. Un idioma sin '
    + 'palabras se ofrecería en la hoja y luego mostraría inglés.',
  documentSection: 'La forma misma',
  formName: 'Nombre de la forma',
  fieldLabel: 'Pregunta',
  fieldHelp: 'Texto de ayuda',
  elementText: 'Texto',
  sectionTitle: 'Título de sección',
  rows: 'Puntos de la lista',
  options: 'Respuestas',
  columns: 'Columnas de la tabla',
  cannotEditBase: 'Este es el idioma propio de la forma. Edite la forma para cambiar estas palabras.',
  noPermission: 'No tiene permiso para traducir formas.',
  pickVersion: 'Versión',
}
